export default __webpack_public_path__ + "static/media/survey.28d1d052.svg";